import React, { FC, useContext, useEffect } from 'react';
import { useHistory }                       from 'react-router';

import { RouterUtility }                        from '../../../../util';
import { useLogout }                            from '../../../../hooks';
import { CorvalUtilHexColors, SemanticUIColor } from '../../../../types';
import { DynamicComponentsContext }             from '../../../contexts';
import { Page }                                 from '../../../containers';
import { LoadingIndicator }                     from '../../../components/util/loading/LoadingIndicator';
import { CorvalStylizedHexContainer }           from '../../../components/product/CorvalStylizedHexContainer';
import { promisedTimeout }                      from '../../../../util/FunctionalUtility';
import { CONSTANTS }                            from '../../../../constants';
import { PageMeta }                             from '../../../containers/PageMeta';

const LogoutPage: FC = ( props ) => {
	
	let { logout }                     = useLogout(),
	    { toasts: [ , toastActions ] } = useContext( DynamicComponentsContext );
	
	// use graph to log us out
	useEffect( () => {
		
		promisedTimeout( CONSTANTS.UI.DISPLAY.TRANSITION_DELAY ).then( () => {
			
			logout( () => {
				
				toastActions.info( "Logout Successful" );
				
			} );
		} );
		
	}, [] );
	
	return (
		<Page name={ 'logout' }
		      showTop={ false }
		      showNav={ false }
		      monitorUserActivity={ false }
		      showToggleMode={ false }
		      ignoreDisplaySettings={ true }>
			
			<CorvalStylizedHexContainer inverted fill={ 'area' } bgColor={ SemanticUIColor.BLUE } fadeColor={ CorvalUtilHexColors.DARK_BLUE } fadeDirection={ 'down' }/>
			
			<PageMeta title={ 'Logout' }>
				
				<LoadingIndicator inverted isActive dimmer={ false } label={ 'Logging out...' }/>
			
			</PageMeta>
		
		</Page>
	);
}

export default LogoutPage;
